import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-editor" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_5 = {
  key: 1,
  class: "tab-style"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "switchs" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "color-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "color-group" }
const _hoisted_15 = {
  key: 2,
  class: "tab-advanced"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "line-group" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "line-group" }
const _hoisted_24 = ["value"]
const _hoisted_25 = ["value"]
const _hoisted_26 = ["value"]
const _hoisted_27 = ["value"]

import { computed, onMounted, ref, watch } from "vue";
import { ColorPicker } from "vue3-colorpicker";
import cloneDeep from "lodash-es/cloneDeep";
import "vue3-colorpicker/style.css";
// types
import type { ReportBlockType } from "@/common/types/report";
// components
import { baseSelect, baseSwitch, baseTextEditor } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'text-editor',
  props: {
    block: {},
    zoom: {}
  },
  emits: ["block:update"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v6d58fdd9": (textAlign.value)
}))

const props = __props;

const emit = __emit;

const DEFAULT_STYLE = {
  background: "#ffffff",
  color: "#000000",
  "font-size": "16px",
  "font-style": "normal",
  "font-family": "Verdana",
  "font-weight": "normal",
  "line-height": "1.6",
  "text-align": "left",
  "text-decoration": "none",
};

const internalBlock = ref(cloneDeep(props.block));
const internalStyle = ref({ ...DEFAULT_STYLE });
const selectedTab = ref<string>("content");

const margins = ref({
  unit: "px",
  top: "0",
  right: "0",
  bottom: "0",
  left: "0",
});

const paddings = ref({
  unit: "px",
  top: "0",
  right: "0",
  bottom: "0",
  left: "0",
});

const textAlign = computed(() => internalStyle.value["text-align"]);

const optionsFonts = computed(() => [
  { option: "Arial", value: "Arial" },
  { option: "Calibri", value: "Calibri" },
  { option: "Courier", value: "Courier" },
  { option: "Georgia", value: "Georgia" },
  { option: "Open Sans", value: "Open Sans" },
  { option: "Sans Serif", value: "sans-serif" },
  { option: "Times New Roman", value: "Times New Roman" },
  { option: "Verdana", value: "Verdana" },
]);

const optionsFontSize = computed(() => [
  { option: "10px", value: "10px" },
  { option: "11px", value: "11px" },
  { option: "12px", value: "12px" },
  { option: "13px", value: "13px" },
  { option: "14px", value: "14px" },
  { option: "15px", value: "15px" },
  { option: "16px", value: "16px" },
  { option: "17px", value: "17px" },
  { option: "18px", value: "18px" },
  { option: "20px", value: "20px" },
  { option: "22px", value: "22px" },
  { option: "24px", value: "24px" },
  { option: "26px", value: "26px" },
  { option: "28px", value: "28px" },
  { option: "30px", value: "30px" },
]);

const optionsAlign = computed(() => [
  { option: "Esquerda", value: "left" },
  { option: "Centro", value: "center" },
  { option: "Direita", value: "right" },
  { option: "Justificado", value: "justify" },
]);

const optionsUnit = computed(() => [
  { option: "px", value: "px" },
  { option: "%", value: "%" },
  { option: "em", value: "em" },
  { option: "rem", value: "rem" },
]);

const tabs = computed(() => [
  {
    key: "content",
    label: "Conteúdo",
  },
  {
    key: "style",
    label: "Estilo",
  },
  {
    key: "advanced",
    label: "Avançado",
  },
]);

function formatUnit(value: string) {
  if (value?.endsWith("rem")) {
    return "rem";
  }
  if (value?.endsWith("em")) {
    return "em";
  }
  if (value?.endsWith("px")) {
    return "px";
  }
  if (value?.endsWith("%")) {
    return "%";
  }

  return "px";
}

function formatStyleToNumber(value?: string | null) {
  if (value === "" || value === undefined || value === null) {
    return "0";
  }
  return value
    ?.replace("px", "")
    ?.replace("%", "")
    ?.replace("rem", "")
    ?.replace("em", "");
}

function initialize(block: ReportBlockType) {
  internalBlock.value = {
    ...block,
    style: {
      ...DEFAULT_STYLE,
      ...block.style,
    },
  };

  internalStyle.value = {
    ...DEFAULT_STYLE,
    ...block.style,
  };

  margins.value = {
    unit: formatUnit(block.style["margin-top"]) ?? "px",
    top: formatStyleToNumber(block.style["margin-top"]),
    bottom: formatStyleToNumber(block.style["margin-bottom"]),
    right: formatStyleToNumber(block.style["margin-right"]),
    left: formatStyleToNumber(block.style["margin-left"]),
  };

  paddings.value = {
    unit: formatUnit(block.style["padding-top"]) ?? "px",
    top: formatStyleToNumber(block.style["padding-top"]),
    bottom: formatStyleToNumber(block.style["padding-bottom"]),
    right: formatStyleToNumber(block.style["padding-right"]),
    left: formatStyleToNumber(block.style["padding-left"]),
  };
}

function onUpdate(key: keyof typeof internalBlock.value, value: any) {
  internalBlock.value = {
    ...internalBlock.value,
    [key]: value,
  };

  emit("block:update", {
    block_id: internalBlock.value.block_id,
    payload: {
      [key]: value,
    },
  });
}

function changeSwitch(
  key: keyof typeof internalStyle.value,
  checked: boolean,
  value: string
) {
  const defaultValues = {
    "font-weight": "normal",
    "font-style": "normal",
    "text-align": "left",
  };

  if (!checked) {
    internalStyle.value[key] = defaultValues[key as never];
  } else {
    internalStyle.value[key] = value;
  }

  onUpdate("style", internalStyle.value);
}

function inputMargin(key: keyof typeof margins.value, event: any) {
  const value = event.target.value;

  margins.value[key] = value;

  internalStyle.value = {
    ...internalStyle.value,
    ...{
      "margin-top": `${margins.value.top}${margins.value.unit}`,
      "margin-right": `${margins.value.right}${margins.value.unit}`,
      "margin-bottom": `${margins.value.bottom}${margins.value.unit}`,
      "margin-left": `${margins.value.left}${margins.value.unit}`,
    },
  };

  onUpdate("style", internalStyle.value);
}

function inputPadding(key: keyof typeof paddings.value, event: any) {
  const value = event.target.value ?? 0;
  const sanizedValue = value.replace(/[^0-9]/g, "");

  paddings.value[key] = sanizedValue;

  internalStyle.value = {
    ...internalStyle.value,
    ...{
      "padding-top": `${paddings.value.top}${paddings.value.unit}`,
      "padding-right": `${paddings.value.right}${paddings.value.unit}`,
      "padding-bottom": `${paddings.value.bottom}${paddings.value.unit}`,
      "padding-left": `${paddings.value.left}${paddings.value.unit}`,
    },
  };

  onUpdate("style", internalStyle.value);
}

function normalizeHex(e: any) {
  let v = e.target.value.toLowerCase();

  // Força começar com #
  if (!v.startsWith("#")) v = "#" + v;

  // Aceita somente caracteres hexadecimais
  v = v.replace(/[^#0-9a-f]/g, "");

  // Máximo #RRGGBB
  if (v.length > 7) v = v.slice(0, 7);

  e.target.value = v;
  internalStyle.value.background = v;
}

watch(
  () => props.block,
  (newValue) => {
    if (newValue) {
      initialize(newValue);
    }
  },
  { deep: true }
);

onMounted(() => {
  if (props.block) {
    initialize(props.block);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.key,
          class: _normalizeClass(["tab", {
            active: selectedTab.value === item.key,
          }]),
          onClick: ($event: any) => (selectedTab.value = item.key)
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ]),
    (selectedTab.value === 'content')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (internalBlock.value)
            ? (_openBlock(), _createBlock(_unref(baseTextEditor), {
                key: 0,
                modelValue: internalBlock.value.content,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalBlock.value.content) = $event)),
                "toolbar-id": "block-toolbar",
                floating: true,
                selected: true,
                style: _normalizeStyle(internalBlock.value.style),
                onUpdate: _cache[1] || (_cache[1] = ($event: any) => (onUpdate('content', $event)))
              }, null, 8, ["modelValue", "style"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'style')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[30] || (_cache[30] = _createElementVNode("label", null, "Estilo de Fonte", -1)),
            _createVNode(_unref(baseSelect), {
              modelValue: internalStyle.value['font-family'],
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((internalStyle.value['font-family']) = $event)),
              value: internalStyle.value['font-family'],
              height: "32px",
              "is-empty": false,
              options: optionsFonts.value,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (onUpdate('style', internalStyle.value)))
            }, null, 8, ["modelValue", "value", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[31] || (_cache[31] = _createElementVNode("label", null, "Alinhamento", -1)),
            _createVNode(_unref(baseSelect), {
              modelValue: internalStyle.value['text-align'],
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((internalStyle.value['text-align']) = $event)),
              value: internalStyle.value['text-align'],
              height: "32px",
              "is-empty": false,
              options: optionsAlign.value,
              onChange: _cache[5] || (_cache[5] = ($event: any) => (onUpdate('style', internalStyle.value)))
            }, null, 8, ["modelValue", "value", "options"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[32] || (_cache[32] = _createElementVNode("label", null, "Tamanho da Fonte", -1)),
            _createVNode(_unref(baseSelect), {
              modelValue: internalStyle.value['font-size'],
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((internalStyle.value['font-size']) = $event)),
              value: internalStyle.value['font-size'],
              height: "32px",
              "is-empty": false,
              options: optionsFontSize.value,
              onChange: _cache[7] || (_cache[7] = ($event: any) => (onUpdate('style', internalStyle.value)))
            }, null, 8, ["modelValue", "value", "options"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[33] || (_cache[33] = _createElementVNode("label", null, "Fromatação", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(baseSwitch), {
                value: internalStyle.value['font-weight'] === 'bold',
                label: "Negrito",
                onChange: _cache[8] || (_cache[8] = ($event: any) => (changeSwitch('font-weight', $event, 'bold')))
              }, null, 8, ["value"]),
              _createVNode(_unref(baseSwitch), {
                value: internalStyle.value['font-style'] === 'italic',
                label: "Itálico",
                onChange: _cache[9] || (_cache[9] = ($event: any) => (changeSwitch('font-style', $event, 'italic')))
              }, null, 8, ["value"]),
              _createVNode(_unref(baseSwitch), {
                value: internalStyle.value['text-decoration'] === 'underline',
                label: "Sublinhado",
                onChange: _cache[10] || (_cache[10] = ($event: any) => (changeSwitch('text-decoration', $event, 'underline')))
              }, null, 8, ["value"]),
              _createVNode(_unref(baseSwitch), {
                value: internalStyle.value['text-decoration'] === 'line-through',
                label: "Tachado",
                onChange: _cache[11] || (_cache[11] = ($event: any) => (changeSwitch('text-decoration', $event, 'line-through')))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[34] || (_cache[34] = _createElementVNode("label", null, "Cor da Fonte", -1)),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: "color-input",
                type: "text",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((internalStyle.value['color']) = $event)),
                maxlength: "7",
                onInput: normalizeHex,
                onChange: _cache[13] || (_cache[13] = ($event: any) => (onUpdate('style', internalStyle.value))),
                placeholder: "#000000"
              }, null, 544), [
                [_vModelText, internalStyle.value['color']]
              ]),
              _createVNode(_unref(ColorPicker), {
                pureColor: internalStyle.value['color'],
                "onUpdate:pureColor": [
                  _cache[14] || (_cache[14] = ($event: any) => ((internalStyle.value['color']) = $event)),
                  _cache[15] || (_cache[15] = ($event: any) => (onUpdate('style', internalStyle.value)))
                ],
                format: "hex"
              }, null, 8, ["pureColor"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[35] || (_cache[35] = _createElementVNode("label", null, "Cor de Fundo", -1)),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                class: "color-input",
                type: "text",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((internalStyle.value['background']) = $event)),
                maxlength: "7",
                onInput: normalizeHex,
                onChange: _cache[17] || (_cache[17] = ($event: any) => (onUpdate('style', internalStyle.value))),
                placeholder: "#000000"
              }, null, 544), [
                [_vModelText, internalStyle.value['background']]
              ]),
              _createVNode(_unref(ColorPicker), {
                class: "color-input",
                pureColor: internalStyle.value['background'],
                "onUpdate:pureColor": [
                  _cache[18] || (_cache[18] = ($event: any) => ((internalStyle.value['background']) = $event)),
                  _cache[19] || (_cache[19] = ($event: any) => (onUpdate('style', internalStyle.value)))
                ],
                format: "hex"
              }, null, 8, ["pureColor"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'advanced')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[41] || (_cache[41] = _createElementVNode("label", null, "Margem", -1)),
            _createElementVNode("div", _hoisted_17, [
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "label" }, "Unidade:", -1)),
              _createVNode(_unref(baseSelect), {
                modelValue: margins.value.unit,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((margins.value.unit) = $event)),
                value: margins.value.unit,
                height: "30px",
                "is-empty": false,
                options: optionsUnit.value
              }, null, 8, ["modelValue", "value", "options"]),
              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "label" }, "Superior:", -1)),
              _createElementVNode("input", {
                value: margins.value.top,
                type: "number",
                onInput: _cache[21] || (_cache[21] = ($event: any) => (inputMargin('top', $event)))
              }, null, 40, _hoisted_18),
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "label" }, "Inferior:", -1)),
              _createElementVNode("input", {
                value: margins.value.bottom,
                type: "number",
                onInput: _cache[22] || (_cache[22] = ($event: any) => (inputMargin('bottom', $event)))
              }, null, 40, _hoisted_19),
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "label" }, "Esquerda:", -1)),
              _createElementVNode("input", {
                value: margins.value.left,
                type: "number",
                onInput: _cache[23] || (_cache[23] = ($event: any) => (inputMargin('left', $event)))
              }, null, 40, _hoisted_20),
              _cache[40] || (_cache[40] = _createElementVNode("div", { class: "label" }, "Direita:", -1)),
              _createElementVNode("input", {
                value: margins.value.right,
                type: "number",
                onInput: _cache[24] || (_cache[24] = ($event: any) => (inputMargin('right', $event)))
              }, null, 40, _hoisted_21)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[47] || (_cache[47] = _createElementVNode("label", null, "Preenchimento", -1)),
            _createElementVNode("div", _hoisted_23, [
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "label" }, "Unidade:", -1)),
              _createVNode(_unref(baseSelect), {
                modelValue: paddings.value.unit,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((paddings.value.unit) = $event)),
                value: paddings.value.unit,
                height: "30px",
                "is-empty": false,
                options: optionsUnit.value
              }, null, 8, ["modelValue", "value", "options"]),
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "label" }, "Superior:", -1)),
              _createElementVNode("input", {
                value: paddings.value.top,
                type: "number",
                onInput: _cache[26] || (_cache[26] = ($event: any) => (inputPadding('top', $event)))
              }, null, 40, _hoisted_24),
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "label" }, "Inferior:", -1)),
              _createElementVNode("input", {
                value: paddings.value.bottom,
                type: "number",
                onInput: _cache[27] || (_cache[27] = ($event: any) => (inputPadding('bottom', $event)))
              }, null, 40, _hoisted_25),
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "label" }, "Esquerda:", -1)),
              _createElementVNode("input", {
                value: paddings.value.left,
                type: "number",
                onInput: _cache[28] || (_cache[28] = ($event: any) => (inputPadding('left', $event)))
              }, null, 40, _hoisted_26),
              _cache[46] || (_cache[46] = _createElementVNode("div", { class: "label" }, "Direita:", -1)),
              _createElementVNode("input", {
                value: paddings.value.right,
                type: "number",
                onInput: _cache[29] || (_cache[29] = ($event: any) => (inputPadding('right', $event)))
              }, null, 40, _hoisted_27)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})